<template>
	<div class="container-lost">
		<div class="select-background">
			<BusinessesSelect class="select-isolated" />
		</div>
		<p>{{ getString('user_is_lost') }}<br><br>{{ getString('user_is_lost_2') }}</p>
	</div>
</template>

<script>
import {useLanguageStore} from "@/shared/stores";
import BusinessesSelect from "@/console-new/components/shared/BusinessesSelect.vue";
import {useUserStore} from "@/user/stores";

export default {
	components: {BusinessesSelect},
	setup() {
		const languageStore = useLanguageStore();
		const userStore = useUserStore();
		return {getString: languageStore.getString, userStore};
	},
	name: "LostView",
	watch: {
		"userStore.currBusiness": {
			handler: function(newBusinesses, oldBusinesses) {
				if(newBusinesses && this.$route.path.includes('/lost')) {
					this.$router.push("/");
				}
			}
		},
	}
}
</script>

<style scoped lang="scss">
.container-lost {
	display: flex;
	justify-content: flex-start;
	align-items: center;
	flex-direction: column;
	height: 100%;
	width: 100%;

	p {
		font-size: 14px;
		font-weight: 500;
		color: var(--color-txt-2);
		padding: 10px;
		max-width: 600px;
		text-align: center;
	}

	.select-background {
		margin-bottom: 20px;
		width: 100%;
		display: flex;
		justify-content: flex-start;
		align-items: center;
		background-color: var(--color-bg-primary-2);


	}

}
</style>